module.exports = __webpack_public_path__ + "static/img/0024.b6282867.png";